import React from 'react';
import { CtaButton } from './CtaButton';
import { coaches } from '../data/coaches';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const HERO_BACKDROP = 'https://cdn.magicpatterns.com/patterns/generated-images/f705c312-0882-44fa-b4a1-13b85dcae9e3.jpg';
const chips = ['6 Volumes', '5 Bonuses', '52-Week Calendar', '156 × 45-min sessions', 'EMOM · AMRAP · Tabata', 'Beginner → Advanced scaling'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it, clip it, coach it'];

/**
 * Proof line under the CTA. Swap for a real rating + buyer count
 * (e.g. "4.9/5 from 1,200+ coaches") once you have verified reviews.
 */
const PROOF_LINE = <>
    Built for <span className="font-bold text-white" data-id="element-111" data-mp="nbez9j5b8oyt">independent bootcamp &amp; group fitness coaches</span>{' '}
    in the US, UK &amp; Australia
  </>;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-navy-deep" data-id="element-112" data-mp="3825wymt9u1js">
      <img src={HERO_BACKDROP} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-113" data-mp="3j8sdfvbir9n7" />
      <div className="pointer-events-none absolute inset-0 bg-navy-deep/70" aria-hidden="true" data-id="element-114" data-mp="3o59c3jgch6ej" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-5 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-10" data-id="element-115" data-mp="3e9625rf943h1">
        <div className="grid gap-7 lg:grid-cols-[1.02fr_.98fr] lg:items-center lg:gap-14" data-id="element-116" data-mp="30hhohjpct6xy">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-117" data-mp="358howyxom757">
            <p className="text-[10px] font-bold uppercase tracking-[1.6px] text-gold sm:text-[11px]" data-id="element-118" data-mp="35a2jupnwrs3l">
              The Decided Bootcamp · for bootcamp &amp; group fitness coaches
            </p>
            <h1 className="mt-2.5 font-display text-[34px] font-bold uppercase leading-[.94] tracking-tight text-white sm:text-5xl lg:text-6xl xl:text-7xl" data-id="element-119" data-mp="2vj7sj6vt22ba">
              Your next bootcamp class is{' '}
              <span className="mark-slash" data-id="element-120" data-mp="2lmv0edfwrwin">
                <span data-id="element-121" data-mp="s2jjlmv9pier">already decided.</span>
              </span>
            </h1>
          </div>

          <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-122" data-mp="nat6xa8uyik6">
            <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={1024} height={694} className="mx-auto w-full max-w-[580px] lg:max-w-none" data-id="element-123" data-mp="ibyq2dugb42p" />
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-124" data-mp="1b0drtyoknpw3">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-base lg:text-lg" data-id="element-125" data-mp="161axp9a4r42w">
              52 weeks of dated, ready-to-teach 45-minute sessions — Monday,
              Wednesday, Friday — with Beginner, Regular and Advanced scaling on
              every page. Plus swaps for rain, small spaces and missing gear, and
              the scripts to lead the room. Not another library to choose from —
              the session itself, already picked.
            </p>

            <ul className="mt-5 flex flex-wrap gap-1.5 sm:gap-2" data-id="element-126" data-mp="1x9kugm9v74h7">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white/70 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-127" data-mp="21amu347p1ijp">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-7 w-full max-w-md lg:mx-0" data-id="element-128" data-mp="2g0luzeqmv82v">
              <CtaButton data-id="element-129" data-mp="2g25bn6g7bl56">Get The Decided Bootcamp</CtaButton>
            </div>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-130" data-mp="2kx2iq7tx7kff">
              <ul className="flex -space-x-2.5" data-id="element-131" data-mp="2p1a5hzgtiqb0">
                {coaches.map((coach, i) => <li key={`${coach.name}-${i}`} data-id="element-132" data-mp="2tysiq21vbrot" data-mpi={i}>
                    <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-9 w-9 rounded-full border-2 border-navy-deep object-cover sm:h-10 sm:w-10" data-id="element-133" data-mp="umzh1s44xy5r" />
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/65" data-id="element-134" data-mp="ea3i7ilawc9m">
                {PROOF_LINE}
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/60 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-135" data-mp="9b0afqdxrrxy">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-136" data-mp="3cr7h85rne5ay">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-137" data-mp="3ct0mphqiyjhd" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}